/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

// All values are unitless
export const ViewBoxWidth = 135;
export const ViewBoxHeight = 12;

const originXPoint = 0;
const originYPoint = 0;

export const ViewBox = `${originXPoint} ${originYPoint} ${ViewBoxWidth} ${ViewBoxHeight}`;
